import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientLegalHeadSaveOrganizationalAndLegalFormMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { SaveOrganizationalAndLegalFormParam } from 'api/types/params/onboarding/saveOrganizationalAndLegalFormParam';

import { parseOrganizationalAndLegalFormParam } from '../helpers/parseOrganizationalAndLegalFormParam';

import { parseLegalClientLegalHeadEntity } from './helpers';

export const useLegalClientLegalHeadSaveOrganizationalAndLegalForm = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientLegalHeadSaveOrganizationalAndLegalFormMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientLegalHeadSaveOrganizationalAndLegalForm
      ? parseLegalClientLegalHeadEntity(
          data.legalClientLegalHeadSaveOrganizationalAndLegalForm
        )
      : undefined,
    loading,
    error,
    saveOrganizationalAndLegalForm: useCallback(
      async (
        id: string,
        legalHeadId: string,
        params: SaveOrganizationalAndLegalFormParam
      ) => {
        const res = await handle({
          variables: {
            id,
            legalHeadId,
            input: parseOrganizationalAndLegalFormParam(params),
          },
        });
        return res?.data?.legalClientLegalHeadSaveOrganizationalAndLegalForm
          ? parseLegalClientLegalHeadEntity(
              res.data.legalClientLegalHeadSaveOrganizationalAndLegalForm
            )
          : undefined;
      },
      [handle]
    ),
  };
};
